import {createContext} from 'react'

const User = createContext({user:null});

export default User;